//Author June Leow
//Date June 13th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, deleteAPICallGenerator, callBackGenerator, formatNumber, showMessage} from '../../util/util';
import {Button, Col, Row, Card, CardHeader, CardBody, Input, Modal, ModalHeader, ModalBody} from 'reactstrap';
import MyDropzone from '../util/my-dropzone';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {useParams} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {
  w9Files:[],
  eandoFiles:[],
  licenseFiles:[],

  eoExpirationDate:'',
  eoCoverage:'',
  yearsOfExp:'',


  w9ErrorMessage:'',
  eoErrorMessage:'',
  licenseErrorMessage:'',
  resizeFilePopUp:false,
  bigFiles:[],
  states:[
    {key:'Alabama',value:'Alabama'},{key:'Alaska',value:'Alaska'},{key:'Arizona',value:'Arizona'},{key:'Arkansas',value:'Arkansas'},{key:'California',value:'California'},{key:'Colorado',value:'Colorado'},{key:'Connecticut',value:'Connecticut'},{key:'Delaware',value:'Delaware'},{key:'Florida',value:'Florida'},{key:'Georgia',value:'Georgia'},{key:'Hawaii',value:'Hawaii'},{key:'Idaho',value:'Idaho'},{key:'Illinois',value:'Illinois'},{key:'Indiana',value:'Indiana'},{key:'Iowa',value:'Iowa'},{key:'Kansas',value:'Kansas'},{key:'Kentucky',value:'Kentucky'},{key:'Louisiana',value:'Louisiana'},{key:'Maine',value:'Maine'},{key:'Maryland',value:'Maryland'},{key:'Massachusetts',value:'Massachusetts'},{key:'Michigan',value:'Michigan'},{key:'Minnesota',value:'Minnesota'},{key:'Mississippi',value:'Mississippi'},{key:'Missouri',value:'Missouri'},{key:'Montana',value:'Montana'},{key:'Nebraska',value:'Nebraska'},{key:'Nevada',value:'Nevada'},{key:'New Hampshire',value:'New Hampshire'},{key:'New Jersey',value:'New Jersey'},{key:'New Mexico',value:'New Mexico'},{key:'New York',value:'New York'},{key:'North Carolina',value:'North Carolina'},{key:'North Dakota',value:'North Dakota'},{key:'Ohio',value:'Ohio'},{key:'Oklahoma',value:'Oklahoma'},{key:'Oregon',value:'Oregon'},{key:'Pennsylvania',value:'Pennsylvania'},{key:'Rhode Island',value:'Rhode Island'},{key:'South Carolina',value:'South Carolina'},{key:'South Dakota',value:'South Dakota'},{key:'Tennessee',value:'Tennessee'},{key:'Texas',value:'Texas'},{key:'Utah',value:'Utah'},{key:'Vermont',value:'Vermont'},{key:'Virgin Islands',value:'Virgin Islands'},{key:'Virginia',value:'Virginia'},{key:'Washington',value:'Washington'},{key:'Washington DC',value:'Washington DC'},{key:'West Virginia',value:'West Virginia'},{key:'Wisconsin',value:'Wisconsin'},{key:'Wyoming',value:'Wyoming'}
  ],
};

//reducer function that perform state update
const reducer = getReducer();


const AppraiserFileUpload  = (props)=>{
  const controller = new AbortController();

  let params = useParams().params;
  

  let w9Value = false;
  let eandoValue = false;
  let eandoExpValue = false;
  let licenseValue = false;

  if(params&&params!==''){
    params = params.split('&');
    if(params){
      for(let i=0;i<params.length;i++){
        let token = params[i].split('=');
        token[1] = token[1].replace('%ForwardSlash', '/');
        token[1] = token[1].replace('%Ampersand', '&');
        token[1] = decodeURIComponent(token[1]);
        console.log(token[0])
        switch(token[0]){
          case 'w9':
            w9Value = true;
            break;
          case 'eando':
            eandoValue = true;
            break;
          case 'eandoexpiration':
            eandoExpValue = true;
            break;
          case 'license':
            licenseValue = true;
            break;
        }
      }
    }
  }
  const typeID = localStorage.getItem('typeID');
  let newInitialState = Object.assign({}, initialState, {
    appraiserFk:typeID,
    w9:w9Value,
    eando:eandoValue,
    eandoExp:eandoExpValue,
    license:licenseValue,
  });

  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGet = getAPICallGenerator(props, {signal:controller.signal});
  const httpPost = postAPICallGenerator(props, {signal:controller.signal});
  const httpPut = putAPICallGenerator(props, {signal:controller.signal});
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const toggleResizeFile=()=>{
    if(state.resizeFilePopUp)
      setState({bigFiles:[]});
    setState({resizeFilePopUp: !state.resizeFilePopUp});
  }

  const buttonHandler=(file)=>{
    if(state.uploadDisabled)
      return;
    setState({uploadDisabled:true},uploadAll(file));
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop=(acceptedFiles, rejectedFiles)=>{
    let existingFiles = state.toUploadFiles.slice();
    let bigFiles = state.bigFiles;

    for(let i=0;i<acceptedFiles.length;i++){
      let file = acceptedFiles[i];
      file.status = 'Pending';
      file.fileType = '';

      let isBigFile = false;
      if(file.size > 40000000){
        isBigFile = true;
        bigFiles.push(file.name);
      }

      let duplicate = false;
      for(let j=0;j<state.toUploadFiles.length;j++){
        if(state.toUploadFiles[j].name===acceptedFiles[i].name){
          duplicate = true;
          setState({errorMessage:'Duplicate file name "'+acceptedFiles[i].name+'"'})
        }
      }
      if(!duplicate && !isBigFile)
        existingFiles.push(file);
    }
    if(bigFiles.length){
      setState({resizeFilePopUp:true, bigFiles:bigFiles});
    }

    setState({toUploadFiles: existingFiles});
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDropW9=(acceptedFiles, rejectedFiles)=>{
    let existingFiles = state.w9Files.slice();
    let bigFiles = state.bigFiles;

    for(let i=0;i<acceptedFiles.length;i++){
      let file = acceptedFiles[i];
      file.status = 'Pending';
      file.fileType = '';

      let isBigFile = false;
      if(file.size > 40000000){
        isBigFile = true;
        bigFiles.push(file.name);
      }

      let duplicate = false;
      for(let j=0;j<state.w9Files.length;j++){
        if(state.w9Files[j].name===acceptedFiles[i].name){
          duplicate = true;
          setState({errorMessage:'Duplicate file name "'+acceptedFiles[i].name+'"'})
        }
      }
      if(!duplicate && !isBigFile)
        existingFiles.push(file);
    }
    if(bigFiles.length){
      setState({resizeFilePopUp:true, bigFiles:bigFiles});
    }

    setState({w9Files: existingFiles});
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDropEAndO=(acceptedFiles, rejectedFiles)=>{
    let existingFiles = state.eandoFiles.slice();
    let bigFiles = state.bigFiles;

    for(let i=0;i<acceptedFiles.length;i++){
      let file = acceptedFiles[i];
      file.status = 'Pending';
      file.fileType = '';

      let isBigFile = false;
      if(file.size > 40000000){
        isBigFile = true;
        bigFiles.push(file.name);
      }

      let duplicate = false;
      for(let j=0;j<state.eandoFiles.length;j++){
        if(state.eandoFiles[j].name===acceptedFiles[i].name){
          duplicate = true;
          setState({errorMessage:'Duplicate file name "'+acceptedFiles[i].name+'"'})
        }
      }
      if(!duplicate && !isBigFile)
        existingFiles.push(file);
    }
    if(bigFiles.length){
      setState({resizeFilePopUp:true, bigFiles:bigFiles});
    }

    setState({eandoFiles: existingFiles});
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDropLicense=(acceptedFiles, rejectedFiles)=>{
    let existingFiles = state.licenseFiles.slice();
    let bigFiles = state.bigFiles;

    for(let i=0;i<acceptedFiles.length;i++){
      let file = acceptedFiles[i];
      file.status = 'Pending';
      file.fileType = '';
      file.licenseNum = '';
      file.licenseExp = '';
      file.licenseType = '';
      file.licenseState = '';

      let isBigFile = false;
      if(file.size > 40000000){
        isBigFile = true;
        bigFiles.push(file.name);
      }

      let duplicate = false;
      for(let j=0;j<state.licenseFiles.length;j++){
        if(state.licenseFiles[j].name===acceptedFiles[i].name){
          duplicate = true;
          setState({errorMessage:'Duplicate file name "'+acceptedFiles[i].name+'"'})
        }
      }
      if(!duplicate && !isBigFile)
        existingFiles.push(file);
    }
    if(bigFiles.length){
      setState({resizeFilePopUp:true, bigFiles:bigFiles});
    }

    setState({licenseFiles: existingFiles});
  }

  const editLicenseInfo=(index, field, value)=>{
    let licenseFiles = state.licenseFiles.slice();

    licenseFiles[index][field] = value;

    setState({licenseFiles:licenseFiles});
  }

  //remove a specific file from the toUpload list.
  const removeToUploadFile=(files,preview)=>{
    let toRemoveIndex = -1;
    for(let i=0;i<state[files].length;i++){
      if(state[files][i].preview===preview){
        toRemoveIndex = i;
      }
    }

    if(toRemoveIndex!==-1){
      let newFiles = state[files].slice();
      newFiles.splice(toRemoveIndex,1);

      setState({[files]:newFiles});
    }
  }

  //format the size to use appropiate unit KB, MB and B and round up to only 1 decimal
  const formatFileSize=(size)=>{
    let intSize = parseInt(size,10);

    if(intSize>=1000000.00)
      return formatNumber(Math.round((intSize*10/1000000))/10)+' MB';
    else if(intSize>=1000)
      return formatNumber(Math.round((intSize*10/1000))/10)+' KB';
    else
      return formatNumber(intSize)+' B';

  }

  //constructing a new file object
  const deepCopyFileObject=(file)=>{
    let newFile = new File([file],file.name);
    newFile.preview = file.preview;
    newFile.fileType = file.fileType;
    newFile.status = file.status;

    if(file.licenseType)
      newFile.licenseType = file.licenseType;
    if(file.licenseState)
      newFile.licenseState = file.licenseState;
    if(file.licenseExp)
      newFile.licenseExp = file.licenseExp;
    if(file.licenseNum)
      newFile.licenseNum = file.licenseNum;
    return newFile
  }


  //on change function when user change the file type drop down in upload file pop up
  const onFileTypeChange=(name, fileType)=>{
    let eoMissing = true;
    let w9Missing = true;
    for(let i=0;i<state.toUploadFiles.length;i++){
      if(state.toUploadFiles[i].name===name){
        let newToUploadFiles = [];

        for(let j=0;j<state.toUploadFiles.length;j++){
          let newFile = deepCopyFileObject(state.toUploadFiles[j]);

          if(j===i)
            newFile.fileType = fileType;

          newToUploadFiles.push(newFile);

          if(newFile.fileType==='W9')
            w9Missing = false;
          else if(newFile.fileType==='E&O')
            eoMissing = false;
        }

        setState({toUploadFiles:newToUploadFiles, w9Missing: w9Missing, eoMissing:eoMissing });
      }
    }

    for(let i=0;i<state.toUploadFiles.length;i++){

    }
  }


  //API call
  const updateProfile=(field, value)=>{
    let parameters = [
      {
        field:'field',
        value:field
      },
      {
        field:'value',
        value:value
      },
      {
        field:'ID',
        value:state.appraiserFk
      }
    ];
    httpPut('appraiser/update', parameters, '', 'Oops, something went wrong and could not update your expiration date. Please try again later.', ()=>{});
  }

  const addNewLicense=(licenseType, licenseNumber, licenseState, licenseExpiration)=>{
    let parameters = [
      {
        field:'licenseNumber',
        value:licenseNumber
      },
      {
        field:'appraiserFk',
        value:state.appraiserFk
      },
      {
        field:'licenseType',
        value:licenseType
      },
      {
        field:'licenseState',
        value:licenseState
      },
      {
        field:'expirationDate',
        value:licenseExpiration
      }
    ];
    httpPost('appraiser/license/create',parameters,'','Oops, something went wrong and could not create the license. Please try again later.',()=>{});
  }

  const uploadAll=(files)=>{
    let preCheck = true;
    let errorMessage = '';

    let type = 'Misc';

    if(files==='w9Files'){
      type = 'W9';
      if(state.w9Files.length<=0){
        setState({w9ErrorMessage:'Please upload your W9'})
        preCheck = false;
      }
    }
    else if(files==='eandoFiles'){
      type = 'E&O';
      console.log(state.eoExpirationDate)
      if(state.eoExpirationDate===''){
        errorMessage = 'Please fill in your E&O expiration date.';
        preCheck = false;
      }
      if(state.eandoFiles.length<=0){
        errorMessage = 'Please upload your E&O.';
        preCheck = false;
      }
      if(state.eoExpirationDate===''){
        errorMessage = 'Please set your E&O expiration date.';
        preCheck = false;
      }
      if(state.eoCoverage===''){
        errorMessage = 'Please set your E&O coverage amount.';
        preCheck = false;
      }

      setState({eoErrorMessage:errorMessage});
    }
    else if(files==='licenseFiles'){
      type = 'License';

      //do precheck
      let licenseFiles = state.licenseFiles.slice();

      for(let i=0;i<licenseFiles.length;i++){
        if(licenseFiles[i].licenseNum===''){
          preCheck = false;
          errorMessage = 'Please fill in your license number using the text box.';
        }
        if(licenseFiles[i].licenseExp===''){
          preCheck = false;
          errorMessage = 'Please fill in your license expiration date using the date picker.';
        }
        if(licenseFiles[i].licenseType===''){
          preCheck = false;
          errorMessage = 'Please fill in your license type using the drop down.';
        }
        if(licenseFiles[i].licenseState===''){
          preCheck = false;
          errorMessage = 'Please fill in your license state using the drop down.';
        }
      }

      if(state.yearsOfExp===''){
        errorMessage = 'Please set your years of experience.';
        preCheck = false;
      }

      if(state.licenseFiles.length<=0)
        errorMessage = 'Please upload your license.';

      setState({licenseErrorMessage:errorMessage});
    }


    let counter = state[files].length;
    //only proceed when no error
    if(preCheck){
      setState({errorMessage:'Uploading...Please do not close the window.'});
      let fileCompleted = 0;
      for(let i=0;i<state[files].length;i++){
        //skip file that has done upload
        if(state[files][i].status==='Done'){
          fileCompleted++;
          continue;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const fileAsBinaryString = reader.result?reader.result:reader.content;
            let base64 = btoa(fileAsBinaryString);
            let callBack = (response)=>{
              let code = response.data.code;

              if(code==='00'){
                //copy the array so we maintaining the immutable state
                let newToUploadFiles = [];

                //deep copy the entire file object array
                for(let j=0;j<state[files].length;j++){
                  let newFile;

                  try{
                    newFile = deepCopyFileObject(state[files][j]);


                    if(newFile.name===state[files][i].name){
                      if(files==='licenseFiles'){
                        addNewLicense(newFile.licenseType, newFile.licenseNum, newFile.licenseState, newFile.licenseExp);
                      }

                      newFile.status='Done';
                      counter = counter-1;
                      if(counter===0){
                        if(files==='w9Files')
                          setState({w9:false});
                        else if(files==='eandoFiles'){
                          setState({eando:false, eandoExp:false});
                          updateProfile('eo_expiration_date',state.eoExpirationDate);
                          updateProfile('eo_coverage',state.eoCoverage);
                        }
                        else if(files==='licenseFiles'){
                          setState({license:false});
                          updateProfile('years_of_experience',state.yearsOfExp);
                        }
                      }
                    }
                    newToUploadFiles.push(newFile);
                  }
                  catch(err){
                    //IE Error , not supporting file consturctor
                  }
                }

                setState({[files]:newToUploadFiles});
              }
              fileCompleted++;
              if(fileCompleted>=state[files].length){
                setState({uploadDisabled:false});
                setState({errorMessage:''});
              }
            };

            let errorCallBack = (error)=>{
              fileCompleted++;

              if(fileCompleted>=state.toUploadFiles.length){
                setState({uploadDisabled:false,errorMessage:''});
              }
            };

            let parameters = [
              {
                field:'appraiserFk',
                value:state.appraiserFk
              },
              {
                field:'file_type',
                value:type
              },
              {
                field:'upload_type',
                value:'Appraiser'
              },
              {
                field:'name',
                value:state[files][i].name
              }
              ,{
                field:'file_encoded',
                value:base64
              }
            ];

            httpPost('appraiser/upload',parameters, 'File "'+state[files][i].name+'" uploaded successfully.', 'Oops, something went wrong and could not upload the file "'+state[files][i].name+'". Please try again later.', callBack, errorCallBack);
        };
        reader.onabort = () => console.log('file reading was aborted');
        reader.onerror = () => {
          showMessage('error','File upload failed, please try again later.');
        };

        reader.readAsBinaryString(state[files][i]);
      }
    }
    else{
      setState({errorMessage:errorMessage});
      setTimeout(()=>setState({uploadDisabled:false}),1000);
    }
  }

  //render
  let bigFileList = state.bigFiles.join(', ');

  let maxDate = moment().add(13, 'months');

  let date;
  if(state.eoExpirationDate!=='')
      date = moment(state.eoExpirationDate).toDate();

  let w9;
  let eando;
  let license;
  

  if(state.w9){
    w9 = <div>
      <Card style={{background:'#f5f5f5'}}>
        <CardHeader className="header-color">
          <center>
              <i className="fa fa-folder"></i> Upload W9
          </center>
        </CardHeader>
        <CardBody>
          <font color="red">*** Please upload your W9.</font>
          <div style={{minHeight:'35px',maxHeight:'35px'}} className="red-color flashit">
            <b>{state.errorMessage}</b>
          </div>
          <br/>
          <div className="my-well">
          <MyDropzone onDrop={onDropW9}/>
            <br/>
            <div className="small-scroll-container red-color">
              <b>{state.w9ErrorMessage}</b>
            </div>
            <div>
              <table className="table file-list-table" cellSpacing="0" cellPadding="0">
                <thead>
                  <tr>
                    <th width="30%">Name</th>
                    <th width="20%">Size</th>
                    <th width="10%"><center>Status</center></th>
                    <th width="10%">Control</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    state.w9Files.map(
                      (file,index)=>{
                        return(
                          <tr key={index}>
                            <td>{file.name}</td>
                            <td>{formatFileSize(file.size)}</td>
                            <td><center>{file.status}</center></td>
                            <td><center><i className="fa fa-times red-color cursor-pointer" onClick={()=>removeToUploadFile('w9Files',file.preview)}></i></center></td>
                          </tr>
                        );
                      }
                    )
                  }
                </tbody>
              </table>
            </div>
            <br/>
          </div>
          <br/>

          <div className="align-right">
            <Button color="warning" disabled={state.uploadDisabled} onClick={(e)=>{buttonHandler('w9Files')}}>Submit</Button>
          </div>
        </CardBody>
      </Card>
      <br/>
    </div>
  }
  if(state.eando || state.eandoExp){
    eando = <div>
      <Card style={{background:'#f5f5f5'}}>
        <CardHeader className="header-color">
          <center>
              <i className="fa fa-folder"></i> Upload E & O
          </center>
        </CardHeader>
        <CardBody>
          <font color="red">*** Please upload your E & O and set it's expiration date and coverage amount</font>
          <div style={{minHeight:'35px',maxHeight:'35px'}} className="red-color flashit">
            <b>{state.errorMessage}</b>
          </div>
          <br/>
          <div className="my-well">
          <MyDropzone onDrop={onDropEAndO}/>
            <br/>
            <div className="small-scroll-container red-color">
              <b>{state.eoErrorMessage}</b>
            </div>
            <div>
              <table className="table file-list-table" cellSpacing="0" cellPadding="0">
                <thead>
                  <tr>
                    <th width="30%">Name</th>
                    <th width="20%">Size</th>
                    <th width="10%"><center>Status</center></th>
                    <th width="10%">Control</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    state.eandoFiles.map(
                      (file,index)=>{
                        return(
                          <tr key={index}>
                            <td>{file.name}</td>
                            <td>{formatFileSize(file.size)}</td>
                            <td><center>{file.status}</center></td>
                            <td><center><i className="fa fa-times red-color cursor-pointer" onClick={()=>removeToUploadFile('eandoFiles',file.preview)}></i></center></td>
                          </tr>
                        );
                      }
                    )
                  }
                </tbody>
              </table>
            </div>
            <br/><br/>
            <div>
              <Row>
                <Col sm="6">
                  <label><font className="red-color">*</font>E&O Expiration Date</label> &nbsp;
                  <div className="display-inline">
                    <DatePicker
                      onChangeRaw={(e)=>{e.preventDefault()}}
                      maxDate={maxDate.toDate()}
                      required={true}
                      className="form-control"
                      selected={date}
                      onChange={(text)=>{(text)&&setState({eoExpirationDate:text.toLocaleDateString('en-CA')})}}
                    />
                  </div>
                </Col>
                <Col sm="6">
                  <label><font className="red-color">*</font>E&O Coverage Amount</label> &nbsp;
                  <div className="display-inline">
                    <Input type="number" value={state.eoCoverage} onChange={(e)=>setState({eoCoverage:e.target.value})}/>
                  </div>
                </Col>
              </Row>
            </div>
            <br/>
          </div>
          <br/>

          <div className="align-right">
            <Button color="warning" disabled={state.uploadDisabled} onClick={(e)=>{buttonHandler('eandoFiles')}}>Submit</Button>
          </div>
        </CardBody>
      </Card>
      <br/>
    </div>
  }
  if(state.license){
    license = <div>
      <Card style={{background:'#f5f5f5'}}>
        <CardHeader className="header-color">
          <center>
              <i className="fa fa-folder"></i> Upload License(s)
          </center>
        </CardHeader>
        <CardBody>
          <font color="red">*** Please upload your License(s) and set your years of experience.</font>
          <div style={{minHeight:'35px',maxHeight:'35px'}} className="red-color flashit">
            <b>{state.errorMessage}</b>
          </div>
          <br/>
          <div className="my-well">
          <MyDropzone onDrop={onDropLicense}/>
            <br/>
            <div className="small-scroll-container red-color">
              <b>{state.licenseErrorMessage}</b>
            </div>
            <div>
              <table className="table file-list-table" cellSpacing="0" cellPadding="0">
                <thead>
                  <tr>
                    <th width="20%">Name</th>
                    <th width="15%">License Type</th>
                    <th width="15%">License #</th>
                    <th width="15%">State</th>
                    <th width="15%">License Exp Date</th>
                    <th width="10%"><center>Status</center></th>
                    <th width="10%">Control</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    state.licenseFiles.map(
                      (file,index)=>{
                        return(
                          <tr key={index}>
                            <td>{file.name}</td>
                            <td><Input type="select" value={file.licenseType} onChange={(e)=>{editLicenseInfo(index, 'licenseType',e.target.value)}}>
                              <option value=""></option>
                              <option value="Unknown">Unknown</option>
                              <option value="Transitional License">Transitional License</option>
                              <option value="License">License</option>
                              <option value="Certified General">Certified General</option>
                              <option value="Certified Residential">Certified Residential</option>
                            </Input>
                            </td>
                            <td><Input type="text" value={file.licenseNum} onChange={(e)=>{editLicenseInfo(index, 'licenseNum',e.target.value)}}/></td>
                            <td><Input type="select" value={file.licenseState} onChange={(e)=>{editLicenseInfo(index, 'licenseState',e.target.value)}}>
                                <option value=""></option>
                                {
                                  state.states.map(
                                    (state, index)=>{
                                      return <option key={index} value={state.value}>{state.value}</option>
                                    }
                                  )
                                }
                              </Input>
                            </td>
                            <td><DatePicker
                              className="form-control"
                              selected={file.licenseExp!==''?moment(file.licenseExp).toDate():null}
                              onChange={(text)=>{(text)&&editLicenseInfo(index, 'licenseExp', text.toLocaleDateString('en-CA'))}}
                            /></td>
                            <td>{formatFileSize(file.size)}</td>
                            <td><center>{file.status}</center></td>
                            <td><center><i className="fa fa-times red-color cursor-pointer" onClick={()=>removeToUploadFile('licenseFiles',file.preview)}></i></center></td>
                          </tr>
                        );
                      }
                    )
                  }
                </tbody>
              </table>
            </div>
            <br/>
            <label><font className="red-color">*</font>Years Of Experience</label> &nbsp;
            <div className="display-inline">
              <Input type="number" value={state.yearsOfExp} onChange={(e)=>setState({yearsOfExp:e.target.value})}/>
            </div>
            <br/>
          </div>
          <br/>

          <div className="align-right">
            <Button color="warning" disabled={state.uploadDisabled} onClick={(e)=>{buttonHandler('licenseFiles')}}>Submit</Button>
          </div>
        </CardBody>
      </Card>
      <br/>
    </div>
  }

  let confirmMessage;

  if(!state.w9 && !state.eando && !state.eandoExp && !state.license){
    confirmMessage = <div>
      <center>
        <br/><br/>
        <b>Profile Updated</b><br/>
        ***Thank you for updating your information, you are all set. You may now close this page.***
      </center>
    </div>
  }

  return(
    <div className="padding">
      <Modal className="my-modal" isOpen={state.resizeFilePopUp} toggle={toggleResizeFile} >
        <ModalHeader hidden={true} toggle={toggleResizeFile}></ModalHeader>
        <ModalBody>
          <center>
            <h5><i className="fa fa-exclamation-triangle"></i> File Too Large</h5>
          </center>

          <b>Your file is larger than <font color="red">40MB</font>. Please resize your following file(s):</b>
          <div>{bigFileList}</div>

          <br/><br/>
          <center>
            <Button color="warning" onClick={toggleResizeFile}>Ok</Button>
          </center>
        </ModalBody>
      </Modal>
      {w9}
      {eando}
      {license}
      {confirmMessage}
    </div>
  );
}


export default AppraiserFileUpload;
